let Settings = { test: 'x' };

export function SetSettings(json) {
    Settings = json;
}

export { Settings as default };
